<template>
  <div>
    <el-dialog :title="title" :visible.sync="isShowModal" :close-on-click-modal="false" width="900px"
               @close="closeDialog">
      <div style="text-align: right; position: absolute; top:20px; right: 100px;">
<!--        <el-button v-print="'#printMe'" icon="el-icon-printer" type="primary">打印</el-button>-->
      </div>
      <div  style="width: 800px; height: 600px; overflow-y: scroll; border: 1px solid #ccc; margin: 0 auto;">
        <div id="printMe" style=" width: 700px; margin: 0 auto; height: 1000px;">
          <div class="stuBox" style="page-break-after:always;padding-bottom: 50px;">
            <el-card class="box-card">
              <div slot="header" class="clearfix font20">中考成绩证明</div>
              <div class="flexCenter" style="width: 300px;">
                <img v-if="detailInfo.scorePhoto" :src="detailInfo.scorePhoto" alt="" style="width: 100%;" v-viewer>
                <span v-else>暂无照片</span>
              </div>
            </el-card>

            <el-card class="box-card" style="margin-top: 20px;">
              <div slot="header" class="clearfix font20">户口簿</div>
              <div class="flexCenter" style="width: 300px;">
                <img v-if="detailInfo.householdPhoto" :src="detailInfo.householdPhoto" alt="" style="width: 100%;" v-viewer>
                <span v-else>暂无照片</span>
              </div>
            </el-card>

            <el-card class="box-card" style="margin-top: 20px;">
              <div slot="header" class="clearfix font20">市民卡</div>
              <div class="flexCenter" style="width: 300px;">
                <img v-if="detailInfo.citizenPhoto" :src="detailInfo.citizenPhoto" alt="" style="width: 100%;" v-viewer>
                <span v-else>暂无照片</span>
              </div>
            </el-card>

            <el-card class="box-card" style="margin-top: 20px;">
              <div slot="header" class="clearfix font20">身份证照片</div>
              <div class="flexCenter" style="width: 300px;">
                <img v-if="detailInfo.idPhoto1" :src="detailInfo.idPhoto1" alt="" style="width: 100%;" v-viewer>
                <span v-else>暂无身份证正面照</span>
              </div>
              <div class="flexCenter" style="width: 300px;">
                <img v-if="detailInfo.idPhoto2" :src="detailInfo.idPhoto2" alt="" style="width: 100%;" v-viewer>
                <span v-else>暂无身份证反面照</span>
              </div>
            </el-card>


            </div>
          </div>


        </div>


    </el-dialog>
  </div>
</template>

<script>

export default {

  props: {
    detailInfo:{
      name: "",
      gender: 0
    },
    baseInfo:{
      type: Object,
      default:{},
    },
    dialogNum:0,
    title:'',
  },
  data() {
    return {
      isShowModal: true,
    }
  },
  mounted() {

  },
  methods: {
    closeDialog() {
      this.$parent.closePrint()
    }
  }
}
</script>

<style scoped="scoped" type="text/less" lang="less">
.stuBox{
  box-sizing: border-box;
  padding-top: 20px;
  position: relative;
  .font20{font-size: 20px;}
  .posIndex{
    position: absolute;
    top: 20px;
    right: 0px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 2px solid #303133;
  }
  .table{
    width: 100%;
  }
}

</style>
